import { render, staticRenderFns } from "./port-detail.vue?vue&type=template&id=c8677d5e&scoped=true&"
import script from "./port-detail.vue?vue&type=script&lang=js&"
export * from "./port-detail.vue?vue&type=script&lang=js&"
import style0 from "./port-detail.vue?vue&type=style&index=0&id=c8677d5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8677d5e",
  null
  
)

export default component.exports